import { decrypterHeaderStorange } from '@helper/util/cryptoStorange'

import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Kpi/LogisticProvider'

export const validateIfShowColumnInTable = (
  headers: ITableHeader[],
  paramsToSend: IParamsToSend
) => {
  let newHeaders: ITableHeader[] = []

  if (localStorage.getItem('@kpiLogisticColumnsTable:')) {
    newHeaders = decrypterHeaderStorange('@kpiLogisticColumnsTable:')
  } else {
    newHeaders = [...headers]
  }

  const headersFormatted: ITableHeader[] = newHeaders.map(item => {
    return (item = {
      group: item.group,
      columns: item.columns.map(column => {
        if (column.id === 'data-execucao-id') {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.periodo.agrupar
          })
        }

        if (
          column.id === 'cd-loja-codigo-id' ||
          column.id === 'cd-loja-nome-id'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.loja.agrupar
          })
        }

        if (column.id === 'gerente-categoria-id') {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.gerenteCategoria.agrupar
          })
        }

        if (column.id === 'gerente-produto-id') {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.gerenteProduto.agrupar
          })
        }

        if (
          column.id === 'categoria-compacta-codigo-id' ||
          column.id === 'categoria-compacta-nome-id'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.categoriaCompacta.agrupar
          })
        }
        if (
          column.id === 'subcategoria-codigo-id' ||
          column.id === 'subcategoria-nome-id'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.subCategoria.agrupar
          })
        }

        if (
          column.id === 'empresa-codigo-id' ||
          column.id === 'empresa-nome-id'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.empresa.agrupar
          })
        }

        return column
      })
    })
  })

  return headersFormatted
}
